import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcFood = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <path
          fill="currentColor"
          d="M10.74 23.285a8.073 8.073 0 0 1-2.136-.553 8.188 8.188 0 0 1-4.87-9.664c.15-.582.323-1.043.6-1.596.33-.656 3.598-5.9 3.899-6.253.495-.582 1.288-1.103 2.055-1.349.182-.058.33-.13.33-.159 0-.03-.075-.205-.167-.39A2.855 2.855 0 0 0 9.2 2.099c-.477-.223-.77-.277-1.505-.277h-.585V0h.581c1.456 0 2.41.34 3.413 1.215l.326.283.426-.42c.475-.468.961-.758 1.59-.947.328-.099.421-.103 2.471-.12l2.13-.018v1.04c0 1.124-.035 1.45-.209 1.97-.322.958-1.13 1.81-2.08 2.19a2.4 2.4 0 0 1-.418.139c-.107 0-.089.067.081.307.421.596 3.445 5.56 3.655 5.999a8.158 8.158 0 0 1-.22 7.434 8.214 8.214 0 0 1-6.3 4.213c-.466.053-1.354.053-1.815 0Zm2.202-1.912c1.241-.253 2.287-.822 3.216-1.752.926-.925 1.486-1.95 1.758-3.217.146-.684.146-1.865 0-2.549-.114-.53-.35-1.204-.57-1.62-.078-.15-.881-1.472-1.783-2.939-1.472-2.393-1.676-2.7-1.982-3.009-.394-.395-.742-.597-1.258-.728a2.553 2.553 0 0 0-1.313 0c-.516.131-.864.333-1.257.728-.307.308-.51.617-1.982 3.008-.901 1.465-1.704 2.788-1.784 2.939a7.21 7.21 0 0 0-.57 1.621c-.146.684-.146 1.865 0 2.549a6.368 6.368 0 0 0 1.635 3.105 6.438 6.438 0 0 0 3.848 1.954c.514.064 1.497.021 2.042-.09ZM14.963 3.55a1.9 1.9 0 0 0 .902-.653c.177-.234.359-.71.359-.939v-.136h-1.043c-.913 0-1.08.012-1.333.09-.343.108-.677.35-.916.663-.177.232-.354.702-.354.939v.131h1.047c.94 0 1.077-.01 1.338-.095ZM10.98 19.644c-1.015-.187-1.835-.608-2.527-1.3a4.48 4.48 0 0 1-1.195-2.073c-.161-.6-.172-1.606-.024-2.19.547-2.154 2.475-3.606 4.639-3.493.276.014.665.067.866.116 2.117.522 3.58 2.473 3.471 4.63-.1 2.001-1.434 3.668-3.357 4.195-.34.094-.565.123-1.049.136-.338.01-.709 0-.824-.02Zm1.257-1.848c1.022-.215 1.882-1.075 2.097-2.097.194-.928-.07-1.803-.747-2.482-.398-.398-.745-.6-1.263-.731a2.748 2.748 0 0 0-1.947.237c-.416.218-.932.75-1.14 1.176-.537 1.095-.34 2.293.514 3.148.68.679 1.557.943 2.486.749Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M0 0h23.333v23.333H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgIcFood;
